import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

const useStyles = makeStyles(() => ({
  root: {
    background: 'var(--surface)',
    border: '1px solid var(--border)',
    borderRadius: 'var(--radius-lg)',
    padding: 'var(--space-6)',
  },
  headerRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 'var(--space-4)',
  },
  title: {
    fontSize: 15,
    fontWeight: 600,
    color: 'var(--text)',
  },
}));

/** Bordered surface card — replaces ad-hoc Paper/classes.card usage (docs/DESIGN_MAKEOVER.md 4.3). */
const Card = ({ title, action, children, className = '', style, ...rest }) => {
  const classes = useStyles();
  return (
    <div className={`${classes.root} ${className}`} style={style} {...rest}>
      {title ? (
        <Box className={classes.headerRow}>
          <Typography className={classes.title}>{title}</Typography>
          {action || null}
        </Box>
      ) : null}
      {children}
    </div>
  );
};

export default Card;
